import { config } from '@/bootstrap/config'
import { LocalStorage } from '@/common/services/storage/LocalStorage'
import { MockStorage } from '@/common/services/storage/MockStorage'

const storage = new LocalStorage(config.environment === 'testing' ? new MockStorage() : localStorage)

export default storage
